import React, { useState, useEffect } from "react";
import { Table, Pagination, Spin, Divider } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import { es } from "date-fns/locale/es";
import { Controller, useForm } from "react-hook-form";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import reportServices from "../../services/report-services";
import supervisionService from "../../services/supervision-service";
import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import lotService from "../../services/lot-service";
import { URL_BASE } from "../../config/url-server";
import moment from "moment";
import config from "../../config/config";
import userService from "../../services/user-service";

import DatePicker from "react-datepicker";

const SupervisionReliability = () => {


  registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS_MAP, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);

  const [initReport, setInitReport] = useState(false);
  const [listSection, setListSection] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);

  const {
    register,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);


  const getLisUsers = async () => {
    let listado = await userService.getListByRol("OPERADOR");
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListUsers(sortedItems);
      //setValue("farm",0)
    }
  };


  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
    }
  };

  const getListSection = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListSection(escoja);
      setListLots(escoja);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("user", "0")
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("user", "0")
    }
  };



  const getLisLots = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListLots(escoja);
      setValue("lot", "0")
      setValue("user", "0")
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      setValue("lot", "0")
      setValue("user", "0")
    }
  };






  const generateExcel = async () => {
    setInitReport(true)

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setLoading(true);
    try {

      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const response = await reportServices.supervisionMetricsDailyExcel(start, end, farmId, sectionId, lotId, userId);
      if (response?.error) {
        toast.error("No hay registros", { autoClose: 1600 })
        return;
      }
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `analisis-supervision-diario ${start} - ${end}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }






  const searchMovements = async (page, pageSize) => {
    setInitReport(true)

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      await supervisionService.synchronizePending(start, end, farmId, sectionId, lotId, userId)
      const response = await reportServices.supervisionMetricsDaily(start, end, farmId, sectionId, lotId, userId);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchMovements = async (page, pageSize) => {
    if (!initReport) return;

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setLoading(true);
    try {

      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")

      const response = await reportServices.supervisionMetricsDaily(page, pageSize, start, end, farmId, sectionId, lotId, userId);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
    }
    setLoading(false);
  };




  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "date",
      key: "date",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Usuario",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Finca",
      dataIndex: "farmName",
      key: "farmName",
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
    },
    // Agrega más columnas según sea necesario
  ];



  const formarPercentage = (value) => {
    //if(value>1) value =1;
    const newValue = (value * 100).toFixed(2);
    return `${newValue} %`
  }

  const selectColorBG = (value) => {
    let color = ""
    if (value >= 0.98) color = "#93ebdc";
    else if (value >= 0.90) color = "#FFEFBF";
    else color = "#f7aeae"
    return color
  }





  useEffect(() => {
    getListFilterUsers()
    getLisFarm();
    fetchMovements(page, pageSize);
  }, [page, pageSize]);

  const getListFilterUsers = async () => {
    const userId = "0"
    try {
      let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const response = await userService.listInSupervision(start, end)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
  }
  useEffect(() => {
    getListFilterUsers();
  }, [startDate, endDate]);



  return (
    <div className="row p-4">
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Metricas de supervisión - confiabilidad</Divider>
      </div>

      <div className="col-12">
        <form className="form-react">
          <div className="row mb-3">
            <div className="col-12 col-sm-10">
              <div className="row">
                <div className="col-12 col-sm-4 ">
                  <label className="text-secondary fw-bold">Finca</label>
                  <select
                    className="form-control text-secondary"
                    {...register("farm")}
                    onChange={(e) => getListSection(e)}
                  >
                    {listFarms.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-12 col-sm-4 ">
                  <label className="text-secondary fw-bold">Sección</label>
                  <select
                    className="form-control text-secondary"
                    {...register("section")}
                    onChange={(e) => getLisLots(e)}
                  >
                    {listSection.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-12 col-sm-4 ">
                  <label className="text-secondary fw-bold">Lote</label>
                  <select
                    className="form-control text-secondary"
                    {...register("lot")}
                    onChange={(e) => {
                      const value = e.target.value;
                      setValue("user", "0")
                    }}
                  >
                    {listLots.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>


                <div className="col-6 col-sm-2">
                  <label className="text-secondary fw-bold">Desde</label>
                  <br />
                  <Controller
                    control={control}
                    name="startDate"
                    defaultValue={startDate}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        locale="es"
                        dateFormat="yyyy-MM-dd"
                        className="form-control text-secondary"
                        selected={field.value}
                        onChange={(date) => {
                          field.onChange(date);
                          setStartDate(date)
                          const endOfMonth = moment(date).endOf("day").toDate();
                          setValue("endDate", endOfMonth);
                          setEndDate(endOfMonth);
                        }}
                      />
                    )}
                  />
                </div>
                <div className="col-6 col-sm-2">
                  <label className="text-secondary fw-bold">Hasta</label>
                  <br />
                  <Controller
                    control={control}
                    name="endDate"
                    defaultValue={endDate}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        locale="es"
                        dateFormat="yyyy-MM-dd"
                        className="form-control text-secondary"
                        selected={field.value}
                        onChange={(date) => {
                          field.onChange(date)
                          const endOfDay = moment(date).endOf("day").toDate();
                          setValue("endDate", endOfDay);
                          setEndDate(endOfDay);
                        }
                        }
                      />
                    )}
                  />
                </div>



                <div className="col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Usuario</label>
                  <select
                    className="form-control text-secondary"
                    {...register("user")}
                    onChange={(e) => {
                      const value = e.target.value;
                    }}
                  >
                    {listUsers.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>


              </div>
            </div>


            <div className="col-12 col-sm-2">

              <div className=" col-12">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => searchMovements(page, pageSize)}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Buscar
                  </button>
                </Spin>
              </div>

              <div className=" col-12">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-success w-100"
                    type="button"
                    onClick={() => generateExcel()}
                  >
                    <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
                  </button>
                </Spin>
              </div>

            </div>
          </div>
        </form>
      </div>


      <Spin spinning={loading}>
        <div className="card mt-3" style={{ minHeight: "400px" }}>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-primary">
                <tr>
                  <td><b>Fecha</b><br />Fecha de<br />supervisión</td>
                  <td><b>Operador</b><br />Funcionario<br />polinizador</td>
                  <td><b>Aplicación</b><br />flores aptas para polinizar<br /> vs flores polinizadas</td>
                  <td><b>Reporte</b><br />flores reportadas<br /> vs polinizadas</td>
                  <td><b>Confiabilidad</b><br />Registros supervision donde:<br />polinizadas = reportadas</td>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {

                  const suma = item.calidad + item.destape + item.marcaje
                  const promedio = suma / 3

                  return (
                    <tr key={index}>
                      <td>{item.date}</td>
                      <td>{item.operatorName}</td>
                      <td style={{ backgroundColor: selectColorBG(item.cobertura) }} >{formarPercentage(item.cobertura)}</td>
                      <td style={{ backgroundColor: selectColorBG(item.polinizacion) }} >{formarPercentage(item.polinizacion)}</td>
                      <td style={{ backgroundColor: selectColorBG(item.confiabilidad) }} >{formarPercentage(item.confiabilidad)}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </Spin>
    </div>
  );




};



export default SupervisionReliability;
